import * as paths from '../../Providers/paths';
import * as rootSelectors from '../../selectors/root';
import * as scheduleRoutines from './scheduleRoutines';
import * as toastRoutines from '../../sagas/routines/toastRoutines';
import { call, cancel, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { deleteFileFromStorageSaga } from '../../sagas/filesSaga';
import { extractFileTypeFromBase64 } from '../../helpers/fileTypeRegex';
import {
    makeSessionsForFirebase,
    selectScheduleDetailsBackground,
    selectScheduleListBackground,
} from './scheduleSelectors';
import { rsf } from '../../globals/firebase';
import { sendStringSaga } from '../../sagas/filesSaga';
import _ from 'lodash';
export function* toggleHidePastEventsSaga(action) {
    const active_event_id = yield select(rootSelectors.selectActiveEventId);
    let payload = action.payload.shouldHidePastEvents === true ? true : false;
    try {
        yield call(rsf.database.patch, paths.moduleConfig(active_event_id, 'schedule', 'listConfig'), {
            shouldHidePastEvents: payload,
        });
        yield put(toastRoutines.setToastSuccess('Event visibility changed!'));
        yield put(scheduleRoutines.toggleHidePastEvents.success(payload));
    } catch (error) {
        yield put(toastRoutines.setToastError('Error updating event visibility settings!'));
        yield put(scheduleRoutines.toggleHidePastEvents.failure(error));
    }
}

export function* setItineraryListVisibilitySaga(action) {
    let shouldHideAllItinerary =  false;
    let shouldHideMyItinerary =  false;
    switch (action.payload){
        case "both":
            shouldHideMyItinerary = false
            shouldHideAllItinerary = false
            break;
        case "all":
            shouldHideMyItinerary = true
            shouldHideAllItinerary = false
            break;
        case "my":
            shouldHideMyItinerary = false
            shouldHideAllItinerary = true
            break;
    }

    const active_event_id = yield select(rootSelectors.selectActiveEventId);
    try {
        yield call(rsf.database.patch, paths.moduleConfig(active_event_id, 'schedule', 'listConfig'), {
            shouldHideMyItinerary,
            shouldHideAllItinerary
        });
        yield put(toastRoutines.setToastSuccess('Itinerary list visibility changed!'));
        yield put(scheduleRoutines.setItineraryListVisibility.success(action.payload));
    } catch (error) {
        yield put(toastRoutines.setToastError('Error updating itinerary list visibility settings!'));
        yield put(scheduleRoutines.setItineraryListVisibility.failure(error));
    }
}

export function* removeScheduleImageSaga(action) {
    const active_event_id = yield select(rootSelectors.selectActiveEventId);
    const currentSchedule = yield select(rootSelectors.selectSchedule);
    const type = _.capitalize(action.payload.type);
    try {
        const config = action.payload.type === 'list' ? 'listConfig' : 'detailsConfig';
        yield put(
            toastRoutines.triggerToast({
                content: `Removing ${type} background`,
                options: { type: 'info', autoClose: true },
            }),
        );
        yield call(rsf.database.delete, paths.moduleConfig(active_event_id, 'schedule', config, 'backgroundImageURL'));
        yield call(
            deleteFileFromStorageSaga,
            currentSchedule[config].backgroundImageURL,
            paths.storage_schedule(active_event_id),
        );
        yield put(
            toastRoutines.triggerToast({
                content: `${type} background removed`,
                options: { type: 'success', autoClose: true },
            }),
        );
    } catch (error) {
        yield put(
            toastRoutines.triggerToast({
                content: `Error removing ${action.payload.name}`,
                options: { type: 'error', autoClose: true },
            }),
        );
    }
}

export function* saveScheduleDetailsBackgroundSaga(action) {
    yield put(
        toastRoutines.triggerToast({
            content: 'Updating details background...',
            options: { type: 'info', autoClose: false },
        }),
    );
    const activeEvent = yield select(rootSelectors.selectActiveEventId);

    const scheduleDetailsBase64 = action.payload.scheduleDetailsBackground['3000'];
    const fileType = extractFileTypeFromBase64(scheduleDetailsBase64);
    const filePath = paths.storage_schedule(activeEvent) + `detailsBackground.${fileType}`;
    const previousDetailsBackground = yield select(selectScheduleDetailsBackground);
    try {
        if (previousDetailsBackground)
            yield call(deleteFileFromStorageSaga, previousDetailsBackground, paths.storage_schedule(activeEvent));

        const downloadablePath1024 = yield call(sendStringSaga, { filePath, imageURL: scheduleDetailsBase64 });
        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'schedule', 'detailsConfig'), {
            backgroundImageURL: downloadablePath1024,
        });
        yield put(
            scheduleRoutines.saveScheduleDetailsBackground.success({
                saveScheduleDetailsBackground: downloadablePath1024,
            }),
        );
        yield put(toastRoutines.dismissToast());
        yield put(toastRoutines.setToastSuccess('Details background updated!'));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        yield put(scheduleRoutines.saveScheduleDetailsBackground.failure(error));
    }
}
export function* saveScheduleListBackgroundSaga(action) {
    yield put(
        toastRoutines.triggerToast({
            content: 'Updating schedule list background...',
            options: { type: 'info', autoClose: false },
        }),
    );
    const activeEvent = yield select(rootSelectors.selectActiveEventId);
    const scheduleListBase64 = action.payload.scheduleListBackground['3000'];
    const fileType = extractFileTypeFromBase64(scheduleListBase64);

    const filePath = paths.storage_schedule(activeEvent) + `listBackground.${fileType}`;
    const previousListBackground = yield select(selectScheduleListBackground);

    try {
        if (previousListBackground)
            yield call(deleteFileFromStorageSaga, previousListBackground, paths.storage_schedule(activeEvent));
        const downloadablePath1024 = yield call(sendStringSaga, { filePath, imageURL: scheduleListBase64 });

        yield call(rsf.database.patch, paths.moduleConfig(activeEvent, 'schedule', 'listConfig'), {
            backgroundImageURL: downloadablePath1024,
        });
        yield put(toastRoutines.dismissToast());
        yield put(
            scheduleRoutines.saveScheduleListBackground.success({ saveScheduleListBackground: downloadablePath1024 }),
        );
        yield put(toastRoutines.setToastSuccess('Schedule list background updated!'));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        yield put(scheduleRoutines.saveScheduleListBackground.failure(error));
    }
}

export function* publishImportedSessionsSaga(action) {
    const activeEvent = yield select(rootSelectors.selectActiveEventId);

    yield put(
        toastRoutines.triggerToast({
            content: 'Publishing sessions to the app...',
            options: { type: 'info', autoClose: false },
        }),
    );
    const sessions = yield select(makeSessionsForFirebase);

    try {
        yield call(rsf.database.patch, paths.moduleData(activeEvent, 'schedule', 'itinerary'), sessions);
        yield put(toastRoutines.dismissToast());
        yield put(toastRoutines.setToastSuccess('Sessions published to the app!'));
        yield put(scheduleRoutines.publishImportedSessions.success(true));
    } catch (error) {
        yield put(toastRoutines.dismissToast());
        // yield put(scheduleRoutines.saveScheduleListBackground.failure(error));
    }
}

function* syncShcheduleSaga() {
    const active_event_id = yield select(rootSelectors.selectActiveEventId);
    yield fork(rsf.database.sync, paths.moduleConfig(active_event_id, 'schedule'), {
        successActionCreator: scheduleRoutines.syncSchedule.success,
        failureActionCreator: scheduleRoutines.syncSchedule.failure,
    });
}

export function* resetScheduleSync() {
    yield put(scheduleRoutines.stopSyncingSchedule.trigger());
    yield put(scheduleRoutines.syncSchedule.trigger());
}
export default function* rootSaga() {
    yield takeEvery(scheduleRoutines.saveScheduleDetailsBackground.TRIGGER, saveScheduleDetailsBackgroundSaga);
    yield takeEvery(scheduleRoutines.saveScheduleListBackground.TRIGGER, saveScheduleListBackgroundSaga);
    yield takeEvery(scheduleRoutines.toggleHidePastEvents.TRIGGER, toggleHidePastEventsSaga);
    yield takeEvery(scheduleRoutines.setItineraryListVisibility.TRIGGER, setItineraryListVisibilitySaga);
    yield takeEvery(scheduleRoutines.removeScheduleImage.TRIGGER, removeScheduleImageSaga);
    yield takeEvery(scheduleRoutines.publishImportedSessions.TRIGGER, publishImportedSessionsSaga);
    while (yield take(scheduleRoutines.syncSchedule.TRIGGER)) {
        const bgScheduleSync = yield fork(syncShcheduleSaga);
        yield take(scheduleRoutines.stopSyncingSchedule.TRIGGER);
        yield cancel(bgScheduleSync);
    }
}
